const PENDO_EVENT = {
    SWITCH_INITIATED: 'switchInitiated',
    SWITCH_DEVICE_SELECTED: 'switchDeviceSelected',
    SWITCH_OFFER_RECEIVED: 'switchOfferReceived',
    SWITCH_ARRIVED_HERE: 'switchArrivedHere',
    SWITCH_CANCELED: 'switchCanceled',
    SWITCH_FAILED: 'switchFailed',
    SWITCH_CHAT_HISTORY_SENT: 'switchChatHistorySent',
    SWITCH_CHAT_HISTORY_RECEIVED: 'switchChatHistoryReceived',
};

export default PENDO_EVENT;
